<template>
  <div v-if="authenticatedUser">
    <b-container>
      <!-- Successful recipe share modal -->
      <b-modal @ok="handleOk" id="modal-1" ok-only title="Success">
        <p class="my-2">This Group has been successfully created!</p>
      </b-modal>

      <div class="mt-5 pl-3 pr-3 pb-3 bg-white">
        <b-row class="pl-3 pr-3 pt-4">
          <h3 class="text-left">Create a new Group</h3>
        </b-row>
        <hr />
        <b-row>
          <b-col class="my-container" cols-6>
            <b-form>
              <b-form-group
                ><label
                  class="d-block text-left text-bold"
                  id="input-group-1__BV_label_"
                  >Group name <span class="text-danger">*</span></label
                >
                <b-form-input id="input-1" v-model="EF.name"></b-form-input>
              </b-form-group>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyNameAlert"
                variant="danger"
              >
                This name is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="GroupExistsAlert"
                variant="danger"
              >
                You are not allowed to use this name. This name is used by
                another Group!
              </b-alert>

              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyLockIdAlert"
                variant="danger"
              >
                This Lock Id is invalid!
              </b-alert>
            </b-form>
          </b-col>
          <b-col cols-6>
            <b-form>
              <b-container>
                <b-row>
                  <b-container class="my-container text-left">
                                        <label>Do you want the group to be public readable?</label>
                                        <b-form-checkbox
                                          checked-value="true"
                                          unchecked-value="false"
                                          v-model="EF.publicReadable">
                                          Yes, I do
                                        </b-form-checkbox>
                                        <br>
                    <!-- <label>Need for group consent?</label>
                    <b-form-checkbox
                      checked-value="true"
                      unchecked-value="false"
                      v-model="EF.needGroupConsent"
                    >
                      Yes, there must be
                    </b-form-checkbox>
                    <br />
                    <label>Need for member consent?</label>
                    <b-form-checkbox
                      checked-value="true"
                      unchecked-value="false"
                      v-model="EF.needMemberConsent"
                    >
                      Yes, there must be
                    </b-form-checkbox> -->
                  </b-container>
                </b-row>
              </b-container>
            </b-form>
          </b-col>
        </b-row>
        <br />
        <hr />
        <b-row class="p-3 mb-4">
          <div class="float-right">
            <router-link :to="{ name: 'groups' }">
              <b-button class="link">Cancel</b-button>
            </router-link>
            <button
              @click="SendUserDataToAPI"
              class="btn bg-orange"
              style="margin: 0"
              type="button"
            >
              Submit
            </button>
          </div>
        </b-row>
      </div>
    </b-container>
  </div>
  <div v-else>
    <section class="pb-lg-5 pt-lg-5">
      <b-jumbotron bg-variant="white">
        <template v-slot:header>You do not have access to this page.</template>
        <h3>
          <p>Please login first.</p>
        </h3>
        <h4>
          <router-link :to="{ name: 'home' }">Home page</router-link>
          |
          <router-link :to="{ name: 'login' }">Login</router-link>
        </h4>
      </b-jumbotron>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      emptyNameAlert: false,
      emptyLockIdAlert: false,
      GroupExistsAlert: false,
      userID: "",
      EF: {
        name: "",
        lockId: "",
        publicReadable: true,
        needGroupConsent: true,
        needMemberConsent: true,
      },
    };
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
  },
  methods: {
    handleOk() {
      this.$router.push({ name: "groups" });
    },

    SendUserDataToAPI() {
      if (
        this.EF.name === "" ||
        this.EF.name === null ||
        this.EF.name === undefined
      ) {
        this.emptyNameAlert = true;
      } else {
        this.emptyNameAlert = false;

        const headers = {
          "Content-Type": "application/json",
        };

        var InputGroupData = {
          name: this.EF.name,
           needGroupConsent: this.EF.needGroupConsent,
           needMemberConsent: this.EF.needMemberConsent,
          publicReadable: this.EF.publicReadable,
        };

        axios
          .post("/group?lockId=", InputGroupData, { withCredentials: true })
          .then((response) => {
            console.log(response);
            this.EF.name = "";
            this.EF.publicReadable = false;
            this.EF.needGroupConsent = false;
            this.EF.needMemberConsent = false;
            this.GroupExistsAlert = false;

            this.$bvModal.show("modal-1");
          })
          .catch((error) => {
            console.log(error);
            this.GroupExistsAlert = true;
          });
      }
    },
  },
};
// }
</script>

<style scoped>
.label-align-left {
  float: left;
}

.textareaDescription {
  height: 210px;
}

.inputTypeWidth {
  width: 460px;
}
</style>



// WEBPACK FOOTER //
// src/views/GroupAdd.vue